import { reactive } from 'vue'
import actions from '@/store/organization/actions'
import state from '@/store/organization/state'
import getters from '@/store/organization/getters'

export const organizationModule = {
    state: reactive(state),
    actions,
    getters,
}
